import React from 'react';
import { DropdownSorting } from '../../../../../patterns/00-atoms/dropdown/dropdown.tsx';
import { UBTracking } from '../../../../../components/tracking/ubtracking.ts';

export type MenuSortProps = {
  onChange?: (selectedOption: string) => void;
};

export const MenuSort: React.FunctionComponent<MenuSortProps> = ({ onChange }) => {
  const handleSortChange = (selectedOption: string) => {
    UBTracking.trackEvent.click('menu_filter', 'SORT_BUTTON::' + selectedOption);
    onChange?.(selectedOption);
  };

  return (
    <>
      <DropdownSorting
        options={[
          { value: 'default', label: 'Standard Sortierung' },
          { value: 'most-popular', label: 'Beliebteste zuerst' },
          // { value: 'most-interesting', label: 'Interessanteste zuerst' },
          { value: 'most-expensive', label: 'Teuerste zuerst' },
          { value: 'least-expensive', label: 'Günstigste zuerst' }
        ]}
        onChange={handleSortChange}
        onClick={() => UBTracking.trackEvent.click('menu_filter', 'SORT_BUTTON_OPEN')}
      />
    </>
  );
};
